import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
// components
import VideoList from "@/components/common/video-list.vue";
import PreviewDialog from "@/components/common/preview-dialog.vue";
import { useRaceVideo } from "@/hooks/race-video";
import titleUrl from "@/assets/img/m/homePage/sp-title.png";
import moreUrl from "@/assets/img/m/homePage/sp-more-btn.png";
export default defineComponent({
  name: "Video",
  setup() {
    const {
      videoState,
      clickVideoItemFct
    } = useRaceVideo();
    const router = useRouter();
    const toRaceVideo = () => {
      router.push("/race-video");
    };
    return () => {
      return _createVNode("div", {
        "class": "content-box"
      }, [_createVNode("div", {
        "class": "title-box"
      }, [_createVNode("img", {
        "class": "title",
        "src": titleUrl
      }, null)]), videoState.total ? _createVNode(VideoList, {
        "videoData": videoState.videoData.slice(0, 4),
        "colSpan": 12,
        "onClickVideoItem": itemVal => clickVideoItemFct(itemVal)
      }, null) : _createVNode("div", {
        "class": "not-finished"
      }, [_createTextVNode("\u656C\u8BF7\u671F\u5F85\xB7\xB7\xB7\xB7")]), _createVNode(PreviewDialog, {
        "visible": videoState.showPreview,
        "onUpdate:visible": $event => videoState.showPreview = $event
      }, {
        default: () => [_createVNode("div", {
          "class": "video-erea"
        }, [_createVNode("video", {
          "autoplay": true,
          "muted": true,
          "controls": true
        }, [_createVNode("source", {
          "src": videoState.curVideoItem.url || videoState.curVideoItem.resource
        }, null), _createVNode("p", null, [_createTextVNode("Your browser does not support the video tag.")])])])]
      }), _createVNode("div", {
        "class": "more-btn",
        "onClick": toRaceVideo
      }, [_createVNode("img", {
        "class": "more-btn-img",
        "src": moreUrl
      }, null)])]);
    };
  }
});